export default __webpack_public_path__ + "static/media/SWT0400.34I-26997_-16396_0.94e07b38.jpg";